<template>
  <div class="lecturer scroll-box" @scroll="scrollBox($event)">
    <TopBar :type="2" :pageTitle="'公开考试'" />
    <div class="content-box  examCont"  v-if="commonExamList.length >0">
        <div class="content">
          <ul>
            <li
              v-for="item in commonExamList"
              :key="item.id"
              @click="goExam(item)"
            >
              <p class="exam_name">{{item.exam_name}}</p>  
              <div class="time_">
                <p>开始时间：{{item.start_date}}</p>
                <p>结束时间：{{item.end_date}}</p>
              </div>     
              <div class="down_num">
                限制考试次数：{{item.limit_desc}}
              </div> 
              <div class="btn">去考试</div>    
            </li>
          </ul>
        </div>
      </div>
      <div
      class="nodata"
      v-if="
        commonExamList.length == 0
      "
    >
      <img class="nodata-img" :src="require('@/assets/no-data.png')" />
      <p class="nodata-text">暂无数据</p>
    </div>
    <!-- <pagination v-if="num>0" :num="num" :limit="limit" @getNew="getNew"></pagination> -->
  </div>
</template>
<script>
import pagination from "@/components/pc/pagination.vue";
import TopBar from "@/m/common/topBar.vue";
export default {
  name: 'lecturer',
  data(){
    return {
      num: 0,            //数据总个数
      limit: 12,         //一页显示几个
      nowPage: 1, //当前页码     
      commonExamList:[],//公开考试列表
    }
  },
  components:{
    pagination,
    TopBar
  },
  mounted(){
    this.getOpenExam();      //获取讲师列表
  },
  methods: {
    //获取讲师列表
    getOpenExam(){
      this.$axios.post(`/v1/commonExam/list`,{page:this.nowPage,per_page:this.limit}).then(res=>{
        if(res.code==0){
          this.commonExamList = res.data.data
          this.num = res.data.total
        }
      })
    },
     //翻页
    scrollBox(e) {
      if (
        e.target.scrollHeight - e.target.clientHeight == e.target.scrollTop &&
        this.more
      ) {
        this.nowPage++;
        this.getOpenExam()
      }
    },
    // 跳转到考试
    goExam(item){
        this.$router.push('/commonExam/text/'+item.id)
    },
    //翻页
    getNew(nowPage) {
      this.nowPage = nowPage;
      this.getOpenExam();
    },
  }
}
</script>
<style scoped lang="scss">
.examCont{
  ul{
    display: flex;
    flex-wrap: wrap;
    li{
      width: 90%;
      margin: 20px auto;
      background: #fff;
      box-shadow: 0px 0px 14px 1px rgba(0, 12, 40, 0.14);
      border-radius: 6px;
      box-sizing: border-box;
      padding:30px;
      margin-bottom: 20px;
      p.exam_name{
        font-size: 32px;
        margin-bottom: 10px;
      }
      div.time_{
        margin-top: 15px;
        p{
          font-size: 26px;
          color: #666;
          margin-bottom: 5px;
        }
      }
      .down_num{
        font-size: 26px;
        color: #666;
      }
      div.btn{
        display: inline-block;
        background: #254ed4;
        padding: 10px 20px;
        margin-top: 10px;
        cursor: pointer;
        border-radius: 5px;
        color: #fff;
        font-size: 26px;
      }
    }
  }
}

.nodata {
  width: 574px;
  padding-top: 20px;
  margin: 0 auto;
  text-align: center;
  .nodata-img {
    width: 100%;
    height: auto;
  }
  .nodata-text {
    font-size: 26px;
    color: #999;
    padding-top: 40px;
  }
}
</style>